(function () {

  function parseJSON() {
    const el = document.getElementById('grundpreis-variants-json');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  function currentVariantId() {
    const input = document.querySelector('input[name="id"]');
    return input ? String(input.value) : null;
  }

  function moneyEUR(cents) {
    return new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100) + ' €';
  }

  function update() {
    const data = parseJSON();
    const wrapper = document.querySelector('.grundpreis-wrapper');
    const textEl = wrapper?.querySelector('.grundpreis-text');
    if (!data || !wrapper || !textEl) return;

    const vid = currentVariantId();
    const variant = data.variants.find(v => String(v.id) === vid);
    if (!variant) {
      wrapper.hidden = true;
      return;
    }

    let basePriceCents = null;
    let baseUnit = null;

    // 1) Varianten-Grundpreis (Vorrang)
    if (variant.v_amount && variant.v_unit) {
      let factor = 1;
      baseUnit = variant.v_unit;

      if (baseUnit === 'ml') { factor = 1000; baseUnit = 'l'; }
      if (baseUnit === 'g')  { factor = 1000; baseUnit = 'kg'; }
      if (['stk','stück','st'].includes(baseUnit)) { baseUnit = 'Stk'; }

      basePriceCents = Math.round(variant.price * factor / variant.v_amount);
    }

    // 2) Produkt-Fallback
    if (!basePriceCents && data.product_fallback.value && data.product_fallback.ref && data.product_fallback.unit) {
      basePriceCents = Math.round(Number(data.product_fallback.value) * 100);
      baseUnit = data.product_fallback.ref + ' ' + data.product_fallback.unit;
    }

    if (!basePriceCents || !baseUnit) {
      wrapper.hidden = true;
      return;
    }

    textEl.textContent = `(${moneyEUR(basePriceCents)} / 1 ${baseUnit})`;
    wrapper.hidden = false;
  }

  document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('change', e => {
    if (e.target?.name === 'id') update();
  });
  document.addEventListener('variant:change', update);
  setTimeout(update, 200);

})();
